import { Component, Input } from '@angular/core';

@Component({
  selector: 'cigna-link-parse-href',
  templateUrl: './link-parse-href.component.html',
  styleUrl: './link-parse-href.component.scss',
})
export class LinkParseHrefComponent {
  private _href: string;

  routerLink = '';
  fragment = '';
  queryParams: Record<string, string> | null = null;

  @Input() cignaTrackClicks: any;

  @Input()
  get href(): string {
    return this._href;
  }
  set href(path: string) {
    try {
      const decodedPath = decodeURIComponent(path);

      // Split by fragment first
      const [pathWithQuery, fragmentPart] = decodedPath.split('#');
      this.fragment = fragmentPart || '';

      // Split by query params
      const [routePath, queryString] = pathWithQuery.split('?');
      this.routerLink = routePath;

      // Parse query params if they exist
      if (queryString) {
        const parsedParams: Record<string, string> = {};
        const params = queryString.split('&');
        params.forEach((param) => {
          const [key, value] = param.split('=');
          if (key) {
            parsedParams[key] = value ? decodeURIComponent(value) : '';
          }
        });
        this.queryParams = parsedParams;
      } else {
        this.queryParams = null;
      }
    } catch (e) {
      // Remove query params and fragment from path
      const cleanPath = path.split('?')[0].split('#')[0];
      this.routerLink = cleanPath;
      this.fragment = '';
      this.queryParams = null;
    }
  }
}
